import { Box, styled } from '@mui/material';
import { Plus } from '@styled-icons/bootstrap/Plus';
import ActivitySelection from 'FeatureModules/Activity/Components/ActivitiesTable/ActivitySelection';
import { DialogInner } from 'FeatureModules/Partner/Components/Partners.styles';
import { DialogDefault, ThemeButton } from 'DesignSystem';
import useActivities from 'FeatureModules/Activity/hooks/useActivities';
import React, { FC, useState } from 'react';
import { IDefaultDialogProps } from 'types/dialog.types';
import { BlockContainer } from '../../../Activity/Components/Forms/styles';

interface ISelectActivityDialogProps extends IDefaultDialogProps {
  /**
   * Company id to filter activities by
   */
  ownedById?: string;
  onActivityAdd: (activityId: string) => void;
}

const StyledBlockContainer = styled(BlockContainer)({
  paddingTop: 0,
  height: '100%',
});

const ButtonContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  bottom: 0,
  width: '100%',
  padding: theme.spacing(4),
  boxShadow: theme.custom.shadows[4],
}));

const SelectActivityDialog: FC<ISelectActivityDialogProps> = ({
  open,
  ownedById,
  onActivityAdd,
  onClose,
}) => {
  const [selectedActivityId, setSelectedActivityId] = useState<string>();

  const {
    activities,
    loading,
    filters,
    searchTerm,
    hasNextPage,
    handlePageEndReached,
    handleFilterChange,
    handleSearchTermChange,
    handleFilterReset,
  } = useActivities({ skipUseQueryParams: true, defaultOwnedById: ownedById });

  const onSubmitActivitySelection = () => {
    if (!selectedActivityId) {
      return;
    }
    onActivityAdd(selectedActivityId);
    onClose?.();
  };

  return (
    <DialogDefault
      title="Add existing activity"
      onClose={onClose}
      open={open}
      fullWidth
      icon={Plus}
      maxWidth="xl"
      background="#fff"
    >
      <DialogInner container>
        <StyledBlockContainer container z-index={0}>
          <ActivitySelection
            activities={activities}
            selectedActivityId={selectedActivityId}
            filters={filters}
            hasNextPage={hasNextPage}
            loading={loading}
            searchTerm={searchTerm}
            onSearchTermChange={handleSearchTermChange}
            onSelectionChange={setSelectedActivityId}
            onPageEndReached={handlePageEndReached}
            onFilterChange={handleFilterChange}
            onFilterReset={handleFilterReset}
          />
        </StyledBlockContainer>

        <ButtonContainer>
          <Box display="flex" justifyContent="end" gap={1.8} width="100%">
            <ThemeButton color="BLUE_ICE" size="large" type="button" onClick={onClose}>
              Cancel
            </ThemeButton>
            <ThemeButton
              color="PRIMARY"
              size="large"
              type="submit"
              data-testid="add-ac-button"
              disabled={selectedActivityId === undefined}
              onClick={onSubmitActivitySelection}
            >
              Add
            </ThemeButton>
          </Box>
        </ButtonContainer>
      </DialogInner>
    </DialogDefault>
  );
};

export default SelectActivityDialog;
